import Api from './Indicadores'
export default {
    getTypes(){
        return Api().get("kpi-type/list");
    },
    saveKpi(k){
        return Api().post("kpi/save", k)
    },
    getById(id){
        return Api().get("kpi/data/"+id)
    },
    updateKpi(k){
        return Api().post("kpi/update", k)
    }
    , getBySectorGroupStereotype(sector, group, sterotype){
        return Api().get("kpi/query/sector/"+sector+"/group/"+group+"/stereotype/"+sterotype);
    }
    , getBySectorGroup(sector, group){
        return Api().get("kpi/query/sector/"+sector+"/group/"+group);
    }
    , getBySectorGroup(sector, group, period){
        return Api().get("kpi/query/sector/"+sector+"/group/"+group+"/period/"+period);
    }
    , getBySector(sector){
        return Api().get("kpi/query/sector/"+sector);
    }
    , getBySector(sector, cancelToken){
        if(cancelToken){
            return Api().get(`kpi/query/sector/${sector}`, {
                cancelToken: cancelToken.token
            });
        }
        return Api().get("kpi/query/sector/"+sector);
    },
    getAllBySectorWithEvaluationStatus(sectorId, periodId) {
    return Api().get(`/kpi/query/sector/${sectorId}/all-with-evaluation-status/period/${periodId}`);
    },
    getBySectorPeriod(sector, period, cancelToken){
        if(cancelToken){
            return Api().get("kpi/query/sector/"+sector+"/period/"+period, {
                cancelToken: cancelToken.token
            });
        }
        return Api().get("kpi/query/sector/"+sector+"/period/"+period);
    }
    , getByKpiFather(kpiId){
        return Api().get("kpi/query/master/"+kpiId);
    }
    , getByKpiFatherPeriodSector(kpiId, sectorId, periodId){
        return Api().get("kpi/query/master/"+kpiId+"/period/"+periodId + "/sector/"+sectorId);
    }
    , getByKpiFatherPeriod(kpiId, period){
        return Api().get("kpi/query/master/"+kpiId+"/period/"+period);
    },
    updateArea(kpiId, areaType){
        return Api().get("kpi/update/area-type/"+kpiId+"/"+areaType)
    },
    createByTemplate(sectorId, templateId){
        return Api().post("kpi/template/create/sector/"+sectorId+"/template/"+templateId)
    },
    deleteKpiRecursive(id){
        return Api().delete("kpi/delete/"+id+"/recursive")
    },
    getByTemplate(id){
        return Api().get("kpi/query/template/"+id);
    },
    /**
     * Indicadores operacionais da unidade hospitalar do setor informado,
     * restritos às perspectivas passadas. Usado pelo plano de acao do SWOT.
     * A unidade hospitalar e o nivel operacional sao resolvidos no backend
     * a partir do proprio setor (core.sector.hospital_unit_id).
     */
    getOperationalByPerspectives(sectorId, perspectiveIds, cancelToken){
        const ids = Array.isArray(perspectiveIds) ? perspectiveIds.join(',') : perspectiveIds;
        const config = { params: { perspectiveIds: ids } };
        if(cancelToken){
            config.cancelToken = cancelToken.token;
        }
        return Api().get("kpi/query/operational/sector/"+sectorId+"/perspectives", config);
    },
    createByTemplateBySector(sectorId){
        return Api().post("kpi/template/create/sector/"+sectorId);
    },
    sincronizarKpiFromTemplate(id){
        return Api().post("kpi/template/update/"+id)
    },
    getMethods(){
        return Api().get('kpi-method/list');
    },
    getKpiProcessAvariable(sectorId){
        return Api().get('kpi/process/kpi/'+sectorId);
    },
    updateOse(kpi){
        return Api().post('kpi/ose', kpi);
    },
    updateEpr(kpi){
        return Api().post('kpi/epr', kpi);
    },
    getPeriodGoals(kpiId) {
        return Api().get(`kpi/${kpiId}/period-goals`);
    },
    
    savePeriodGoal(kpiId, periodId, goalData) {
        return Api().post(`kpi/${kpiId}/period/${periodId}/goal`, goalData);
    },
      getCurrentGoal(kpiId, periodId) {
        return Api().get(`kpi/${kpiId}/current-goal/period/${periodId}`);
    },
    
    deletePeriodGoal(kpiId, periodId) {
        return Api().delete(`kpi/${kpiId}/period/${periodId}/goal`);
    },
}
